import { useState, useEffect } from "react";
import { apiFetch } from "../lib/api";
import { IconCreditCard } from "../components/Icons";

export default function Financeiro() {
  const [carregando, setCarregando] = useState(true);
  const [erpClienteId, setErpClienteId] = useState(null);
  const [erroCarregamento, setErroCarregamento] = useState(null);
  const [contratos, setContratos] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await apiFetch("financeiro.php");
      if (res.ok) {
        setErpClienteId(res.data.erp_cliente_id);
        setErroCarregamento(res.data.erro_carregamento);
        setContratos(res.data.contratos);
      } else {
        setErroCarregamento(res.erro || "Não foi possível carregar os dados financeiros.");
      }
      setCarregando(false);
    })();
  }, []);

  return (
    <section style={{ padding: "100px 0 40px" }}>
      <div className="container" style={{ maxWidth: "900px" }}>
        <div className="tag">
          <IconCreditCard style={{ width: "13px", height: "13px" }} />
          Financeiro
        </div>
        <h1
          className="section-title"
          style={{ fontSize: "32px", marginBottom: "6px", color: "var(--text-primary)" }}
        >
          Seus Contratos
        </h1>
        <p style={{ color: "var(--text-secondary)", marginBottom: "32px" }}>
          Consulte aqui os contratos, itens contratados e faturas geradas
          para sua empresa.
        </p>

        {carregando ? (
          <div className="fin-card" style={{ textAlign: "center", padding: "48px 32px" }}>
            <p style={{ color: "var(--text-secondary)" }}>Carregando...</p>
          </div>
        ) : !erpClienteId ? (
          <div className="fin-card" style={{ textAlign: "center", padding: "48px 32px" }}>
            <p style={{ color: "var(--text-secondary)", marginBottom: "8px" }}>
              Nenhum contrato vinculado ao seu cadastro ainda.
            </p>
            <p style={{ fontSize: "13px", color: "var(--text-muted)" }}>
              Entre em contato com nosso suporte para associarmos seu acesso
              ao contrato correto.
            </p>
          </div>
        ) : erroCarregamento ? (
          <div
            className="fin-card"
            style={{ textAlign: "center", padding: "48px 32px", color: "var(--error)" }}
          >
            {erroCarregamento}
          </div>
        ) : contratos.length === 0 ? (
          <div className="fin-card" style={{ textAlign: "center", padding: "48px 32px" }}>
            <p style={{ color: "var(--text-secondary)" }}>
              Nenhum contrato encontrado para sua empresa no momento.
            </p>
          </div>
        ) : (
          contratos.map((contrato) => (
            <div className="fin-card" key={contrato.id}>
              <div className="fin-head">
                <div>
                  <div style={{ fontSize: "18px", fontWeight: 700, fontFamily: "var(--font-display)", color: "var(--text-primary)" }}>
                    Contrato #{contrato.id}
                    {contrato.titulo ? ` — ${contrato.titulo}` : ""}
                  </div>
                  <div style={{ fontSize: "13px", color: "var(--text-muted)", marginTop: "4px" }}>
                    Início: {contrato.data_inicio || "—"}
                    {contrato.duracao_tipo === "fixo"
                      ? ` · Duração: ${contrato.duracao_meses} meses`
                      : " · Duração indeterminada"}
                  </div>
                </div>
                <span
                  className="fin-badge"
                  style={{
                    background: `${contrato.status_cor}22`,
                    color: contrato.status_cor,
                  }}
                >
                  {contrato.status_label}
                </span>
              </div>

              {contrato.itens_recorrentes.length > 0 && (
                <>
                  <div className="fin-sub">Itens recorrentes (cobrados mensalmente)</div>
                  <table className="fin-table">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th className="r">Qtd</th>
                        <th className="r">Valor unit.</th>
                        <th className="r">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contrato.itens_recorrentes.map((item) => (
                        <tr key={item.id}>
                          <td>{item.nome_exibicao}</td>
                          <td className="r">{item.quantidade}</td>
                          <td className="r">{item.valor_unit_fmt}</td>
                          <td className="r">
                            <strong>{item.valor_total_fmt}</strong>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              {contrato.itens_historico.length > 0 && (
                <>
                  <div className="fin-sub">Histórico (itens avulsos já contratados)</div>
                  <table className="fin-table">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th className="r">Qtd</th>
                        <th className="r">Valor unit.</th>
                        <th className="r">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contrato.itens_historico.map((item) => (
                        <tr key={item.id}>
                          <td>{item.nome_exibicao}</td>
                          <td className="r">{item.quantidade}</td>
                          <td className="r">{item.valor_unit_fmt}</td>
                          <td className="r">{item.valor_total_fmt}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              <div className="fin-total">
                <span style={{ color: "var(--text-muted)", fontSize: "13px", alignSelf: "center" }}>
                  Total mensal do contrato:
                </span>
                <strong>{contrato.total_fmt}</strong>
              </div>

              {contrato.faturas.length > 0 ? (
                <>
                  <div className="fin-sub">Faturas geradas</div>
                  <table className="fin-table">
                    <thead>
                      <tr>
                        <th>Competência</th>
                        <th>Número</th>
                        <th className="r">Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contrato.faturas.map((fatura) => (
                        <tr key={fatura.id}>
                          <td>{fatura.competencia}</td>
                          <td>{fatura.numero}</td>
                          <td className="r">
                            <strong>{fatura.valor_fmt}</strong>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : (
                <p style={{ fontSize: "13px", color: "var(--text-muted)", marginTop: "16px" }}>
                  Nenhuma fatura gerada ainda para este contrato.
                </p>
              )}
            </div>
          ))
        )}
      </div>
    </section>
  );
}
